import './App.css';
import './main.css'
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import UploadFile from './pages/UploadFile/UploadFile';
import Result from './pages/Result/result_1';
import LoginApp from './pages/Login/login';
const App = () => {
  const Layout = () => {
    return (
      <div>
        
        <Outlet />
      </div>
    );
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <LoginApp />,
        },
        {
          path: "/upload-file",
          element: <UploadFile />,
        },
        {
          path: "/Result",
          element: <Result />,
        },
      ],
    },

  ]);

  return <RouterProvider router={router} />;
};

export default App;